module.exports = __webpack_public_path__ + "static/media/KJTextLogo.3087c719.png";